import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import Logo from '../assets/logo-blue.png';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white pb-16 md:pb-0">
      <div className="container mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center mb-6 cursor-pointer">
              <img src={Logo} alt="Techno-Stack-Labs" className="h-10 w-10 mr-2" />
              <span className="text-2xl font-bold">Techno-Stack-Labs</span>
            </Link>
            <p className="text-gray-400 mb-6">
              Delivering cutting-edge technology solutions and AI services to businesses worldwide.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/mvp-development" className="text-gray-400 hover:text-white transition duration-300">
                  MVP Development
                </Link>
              </li>
              <li>
                <Link to="/digital-transformation" className="text-gray-400 hover:text-white transition duration-300">
                  Digital Transformation
                </Link>
              </li>
              <li>
                <Link to="/ai-services" className="text-gray-400 hover:text-white transition duration-300">
                AI Services
                </Link>
              </li>
              <li>
                <Link to="/services#web-development" className="text-gray-400 hover:text-white transition duration-300">
                Web Development
                </Link>
              </li>
              <li>
                <Link to="/services#mobile-development" className="text-gray-400 hover:text-white transition duration-300">
                Mobile App Development
                </Link>
              </li>
              <li>
                <Link to="/services#ui-ux-design" className="text-gray-400 hover:text-white transition duration-300">
                UI/UX Design
                </Link>
              </li>
              <li>
                <Link to="/services#data-analytics" className="text-gray-400 hover:text-white transition duration-300">
                Data Analytics
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition duration-300">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-white transition duration-300">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition duration-300">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-gray-400 hover:text-white transition duration-300">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <MapPin size={20} className="mr-3 text-gray-400 flex-shrink-0 mt-1" />
                <span className="text-gray-400">
                Plot No. D-107, Vyapar Marg,<br />
                D-Block, Sector 2, Noida, Uttar Pradesh 201301
                </span>
              </li>
              <li className="flex items-center">
                <Phone size={20} className="mr-3 text-gray-400" />
                <a href="tel:+11234567890" className="text-gray-400 hover:text-white transition duration-300">
                  +91 9167784169
                </a>
              </li>
              <li className="flex items-center">
                <Mail size={20} className="mr-3 text-gray-400" />
                <a href="mailto:info@technostacklabs.com" className="text-gray-400 hover:text-white transition duration-300">
                  info@technostacklabs.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            &copy; {currentYear} Techno-Stack-Labs. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <Link to="/privacy-policy" className="text-gray-400 hover:text-white text-sm transition duration-300">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-gray-400 hover:text-white text-sm transition duration-300">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
